var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 42,
    stroke: "#FF0056",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2484 38.472C30.1178 37.3413 29.7551 36.1147 30.1604 34.792C30.3951 34.0453 31.0778 33.1067 32.2084 31.976L41.0404 23.144C42.4698 21.7147 43.9631 21 45.5204 21C46.7791 21 47.8031 21.3947 48.5924 22.184C49.4031 23.016 49.8084 24.424 49.8084 26.408V61.384C49.8084 63.1333 49.6271 64.3707 49.2644 65.096C48.6031 66.4187 47.3978 67.08 45.6484 67.08C43.8991 67.08 42.6938 66.4187 42.0324 65.096C41.6698 64.3707 41.4884 63.1333 41.4884 61.384V33.768L37.7444 37.512C37.0618 38.1947 36.5391 38.6747 36.1764 38.952C35.8138 39.208 35.4084 39.4107 34.9604 39.56C33.6804 39.9867 32.4431 39.624 31.2484 38.472Z",
    fill: "#FF0056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1);
export default __webpack_public_path__ + "static/media/stage1.54b7b821b243b4c1ea43ca0d2b930671.svg";
export { ForwardRef as ReactComponent };